var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnectToAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1302 6.64026C12.1302 8.65097 10.5002 10.281 8.48951 10.281C6.4788 10.281 4.84879 8.65097 4.84879 6.64026C4.84879 4.62955 6.4788 2.99953 8.48951 2.99953C10.5002 2.99953 12.1302 4.62955 12.1302 6.64026ZM8.49201 11.7411C2.63919 11.7411 1.51547 14.6266 1.51547 15.5522C1.51547 16.4763 2.27795 17.0005 2.99021 17.0005H13.9942C14.706 17.0005 15.4686 16.4767 15.4686 15.5522C15.4686 14.6267 14.3446 11.7411 8.49208 11.7411H8.49201ZM16.2423 8.95713H17.9282C18.2357 8.95713 18.4844 9.20574 18.4845 9.51296C18.4845 9.82018 18.2357 10.0692 17.9283 10.0692H16.2425V11.7546C16.2425 12.0617 15.9938 12.3109 15.6866 12.3109C15.3791 12.3109 15.1304 12.0616 15.1304 11.7546V10.0692H13.4448C13.1376 10.0692 12.8888 9.82019 12.8888 9.51296C12.8888 9.20559 13.1376 8.957 13.4448 8.957H15.1304V7.27139C15.1304 6.96377 15.3793 6.71518 15.6866 6.71518C15.9939 6.71518 16.2425 6.96376 16.2425 7.27139L16.2423 8.95713Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectToAdd);
export default __webpack_public_path__ + "static/media/connect-to-add.26c7e0055b8cae9b2a4162e1fd4ec068.svg";
export { ForwardRef as ReactComponent };